module.exports = "/images/available.png?a64fa4ab8dff5842569bb96a58c196c9";